import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DialogTemplateComponent, ModalType } from '../dialog-template/dialog-template.component';

@Injectable()
export class DialogService {

  constructor(public dialog: MatDialog) { }

  openModal(title: string, message: string, type: ModalType, yes: (Function | null) = null, no: (Function | null) = null) {
    const dialogConfig = new MatDialogConfig();

    // dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: title,
      message: message,
      modalType: type
    };
    dialogConfig.minWidth = 400;

    const dialogRef = this.dialog.open(DialogTemplateComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result:any) => {
      if (result) {
        if (yes) {
          yes();
        }
      } else {
        if (no) {
          no();
        }
      }

    });
  }


  showError(message: string) {
    this.openModal("Well Chron: Error", message, ModalType.ERROR, () => {
    }, () => {
    });
  }

}
